import { jsx } from "react/jsx-runtime";
import { useContext, useCallback } from "react";
import PropTypes from "prop-types";
import { UtilityItem } from "./utility-item.es.js";
import { tokenInputContext } from "./token-input-context.es.js";
import { Tooltip } from "../tooltip/tooltip.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipDefaultExpanded: PropTypes.bool,
  value: PropTypes.string.isRequired
};
const defaultProps = {
  disabled: false,
  tooltip: void 0,
  tooltipDefaultExpanded: false
};
const TokenInputListItem = ({
  children,
  disabled,
  tooltip,
  tooltipDefaultExpanded,
  value,
  ...restProps
}) => {
  const { handleHighlight, handleSelect, highlightedValue } = useContext(tokenInputContext);
  const handleClick = useCallback(() => {
    handleSelect(value);
  }, [handleSelect, value]);
  const handleMouseEnter = useCallback(() => {
    handleHighlight(value);
  }, [handleHighlight, value]);
  return /* @__PURE__ */ jsx(
    Tooltip,
    {
      defaultExpanded: tooltipDefaultExpanded,
      disabled: !tooltip,
      placement: "right",
      title: tooltip,
      children: /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
        UtilityItem,
        {
          disabled,
          highlighted: highlightedValue === value,
          magnitude: "medium",
          onClick: handleClick,
          onMouseEnter: handleMouseEnter,
          ...restProps,
          children
        }
      ) })
    }
  );
};
TokenInputListItem.propTypes = propTypes;
TokenInputListItem.defaultProps = defaultProps;
export {
  TokenInputListItem
};
